import { render, staticRenderFns } from "./PreliminaryDetails.vue?vue&type=template&id=73a027e1"
import script from "./PreliminaryDetails.vue?vue&type=script&lang=js"
export * from "./PreliminaryDetails.vue?vue&type=script&lang=js"
import style0 from "./PreliminaryDetails.vue?vue&type=style&index=0&id=73a027e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports